import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class UploadMacAddressService {

  constructor(private backendService: BackendService) { }

  private path = '/mac-address';

  saveUploadedMacAddress(uploadmacaddressdata) {
  return this.backendService.post(this.path + '/import', uploadmacaddressdata);
  }


  searchMacAddressList(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }

  getMacAddressById(macId) {
    return this.backendService.get(this.path + "/user/" + macId);
  }

  saveMacAddress(data) {

    return this.backendService.post(this.path + "/", data);
  }

  deleteMacAddressById(macId){
    return this.backendService.post(this.path + '/delete/' + macId, {});
  }

  deleteAll(testCenterUser) {
    return this.backendService.post(this.path + "/delete", testCenterUser);
  }


}